// @snippet
/**
 * @class LazyAssets
 */
// import "./modules/Bootstrap/base-component"
import "./modules/Bootstrap/collapse";
// import "./modules/Bootstrap/dom/data"
// import "./modules/Bootstrap/dom/event-handler"
// import "./modules/Bootstrap/dom/manipulator"
// import "./modules/Bootstrap/dom/selector-engine"
// import "./modules/Bootstrap/util/backdrop"
// import "./modules/Bootstrap/util/index"
// import "./modules/Bootstrap/util/sanitizer"
// import "./modules/Bootstrap/util/scrollbar"

const css_data = [
  {
    handle: ".product-card",
    path: "parts/product-card",
  },
  {
    handle: ".product-price-card",
    path: "parts/price-card",
  },
  // {
  //     handle: '#zendesk-widget-placeholder',
  //     path: 'modules/zendesk-widget'
  // },
  {
    handle: ".aspect-ratio",
    path: "general/aspect-ratio",
  },
  {
    handle: ".buttons",
    path: "general/buttons",
  },
  {
    handle: ".gld_tooltip",
    path: "parts/tooltip",
  },
  // {
  //   handle: ".pagination__wrapper",
  //   path: "parts/pagination",
  // }
];

class LazyAssets {
  constructor(observer) {
    this.observer = observer;

    if (this.observer) {
      this.cssObserver();
      this.jsObserver();
    } else {
      this.cssStandard();
      this.jsStandard();
    }
    if (window.cssChunks) {
      this.loadWindowCssChunks();
    }
  }

  loadWindowCssChunks() {
    window.cssChunks.map(async (path) => await this.loadCssChunk(path));
  }

  cssObserver() {
    for (const item of css_data) {
      const { handle, path } = item;
      this.observer.subscribe(handle, async () => {
        await this.loadCssChunk(path);
      });
    }
  }

  async cssStandard() {
    for (const item of css_data) {
      const { handle, path } = item;
      if (document.querySelector(handle)) {
        await this.loadCssChunk(path);
      }
    }
  }

  async loadCssChunk(path) {
    await import(
      /* webpackChunkName: "[request]"*/ `../sass2/chunks/${path}.scss`
    );
  }

  async jsObserver() {
    const jsOnload = await Promise.all([
      this.observer.load(".gld-video-container, .gld-video", () =>
        import(/* webpackChunkName: "modules_video" */ "./modules/Video")
      ),
      // this.observer.load('video[data-lazyload="true"]', (() => import(/* webpackChunkName: "modules_lazyLoadVideos" */ "./modules/LazyLoadVideos"))),
      this.observer.load(".tabs", () =>
        import(/* webpackChunkName: "modules_tabs" */ "./modules/Tabs")
      ),
      this.observer.load(".gld_popup-intrnational-welcome__handle", () =>
        import(
          /* webpackChunkName: "popup_international" */ "./apps-react/InternationalWelcome/InternationalWelcomePopup"
        )
      ),
      this.observer.load(".listrak_form", () =>
        import(
          /* webpackChunkName: "modules_listrakForms"*/ `./modules/ListrakForms`
        )
      ),
      this.observer.load("#zendesk-widget-placeholder", () =>
        import(
          /* webpackChunkName: "modules_zendeskWidget"*/ `./modules/ZendeskWidget`
        )
      ),
      // this.observer.load('.collapse', (() => import(/* webpackChunkName: "modules_bootstrap_collapse"*/ `./modules/Bootstrap/collapse`))),
      this.observer.load("#search__full", () =>
        import(
          /* webpackChunkName: "search_full" */ "./apps-react/Search/components/Search/SearchFull"
        )
      ),
      this.observer.load("#product-recently-viewed", () =>
        import(
          /* webpackChunkName: "product_recently_viewed" */ "./modules/ProductRecentlyViewed"
        )
      ),
      this.observer.load(".countdown-js", () =>
        import(
          /* webpackChunkName: "countdown_timer" */ "./modules/CountdownTimer"
        )
      ),
      this.observer.load(".product-card", () =>
        import(
          /* webpackChunkName: "modules_external-system_dy_product-card" */ "./modules/external-systems/dynamic-yield/ProductCard"
        )
      ),
      this.observer.load("body.template-product", () =>
        import(/* webpackChunkName: "modules_product" */ "./modules/Product")
      ),
      this.observer.load(".accordion", () =>
        import(
          /* webpackChunkName: "modules_accordion" */ "./modules/Accordion"
        )
      ),
      this.observer.load(".gld_popup-listrak", () =>
        import(
          /* webpackChunkName: "modules_newsletter-popup */ "./modules/NewsletterPopup"
        )
        // import(
        //   /* webpackChunkName: "modules_popupListrak" */ "./modules/PopupListrak"
        // )
      ),
      this.observer.load(".gld-btn--scroll-to-next", () =>
        import(
          /* webpackChunkName: "modules_btnScrollToNext" */ "./modules/BtnScrollToNext"
        )
      ),
      this.observer.load("#key-insights ul", () =>
        import(
          /* webpackChunkName: "modules_articleHeaders" */ "./modules/ArticleGenerateHeaders"
        )
      ),
      this.observer.load(".article-social-embed--instagram", () =>
        import(
          /* webpackChunkName: "modules_social-embeds" */ "./modules/SocialEmbeds"
        )
      ),
    ]);

    jsOnload
      .filter((el) => el)
      .forEach((cls) => {
        new cls();
      });

    this.observer.subscribe(".slider--swiper", async (item) => {
      this.loadSlider(item);
    });

    this.observer.subscribe(".dy-api", async (item) => {
      const { default: ApiWidget } = await import(
        /* webpackChunkName: "modules_es_dy_api-widget" */ `./modules/external-systems/dynamic-yield/ApiWidget`
      );

      if (!window.ip) {
        const ipReq = await fetch("//pro.ip-api.com/json/?key=zEZnsyTnaZ4CImn");
        window.ip = await ipReq.json();
        window.ip = window.ip.query;
      }


      ApiWidget.render(item);
    });
  }

  async jsStandard() {
    const jsOnload = await Promise.all([]);

    if (document.querySelector(".slider--swiper")) {
      [...document.querySelectorAll(".slider--swiper")].map((item) => {
        this.loadSlider(item);
      });
    }

    // if (document.querySelector('.gld-video-container')) {
    //     jsOnload.push(await import(/* webpackChunkName: "modules_video" */ "./modules/Video"))
    // }

    if (document.querySelector(".tabs")) {
      jsOnload.push(
        await import(/* webpackChunkName: "modules_tabs" */ "./modules/Tabs")
      );
    }

    if (document.querySelector(".gld_popup-intrnational-welcome__handle")) {
      jsOnload.push(
        await import(
          /* webpackChunkName: "popup_international" */ "./apps-react/InternationalWelcome/InternationalWelcomePopup"
        )
      );
    }

    if (document.querySelector(".listrak_form")) {
      jsOnload.push(
        await import(
          /* webpackChunkName: "modules_listrakForms" */ "./modules/ListrakForms"
        )
      );
    }

    if (document.querySelector("#zendesk-widget-placeholder")) {
      jsOnload.push(
        await import(
          /* webpackChunkName: "modules_zendeskWidget"*/ `./modules/ZendeskWidget`
        )
      );
    }

    // if (document.querySelector('.collapse')) {
    //     jsOnload.push(await import(/* webpackChunkName: "modules_bootstrap_collapse"*/ `./modules/Bootstrap/collapse`))
    // }

    jsOnload
      .filter((el) => el)
      .forEach((cls) => {
        new cls();
      });
  }

  async loadSlider(item) {
    const path = "plugins/swiper";
    await import(
      /* webpackChunkName: "[request]"*/ `../sass2/chunks/${path.trim()}.scss`
    );
    const { default: Slider } = await import(
      /* webpackChunkName: "helpers_slider" */ `./helpers/Slider.js`
    );
    Slider.load(item);
  }
}
export default LazyAssets;
